import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  voidInvoices as voidInvoicesAction,
  fetchPayments as fetchPaymentsAction,
  fetchScheduleTypesFilters as fetchScheduleTypesFiltersAction,
  fetchXeroAccountsFilters as fetchXeroAccountsFiltersAction,
  fetchCreditNotes as fetchCreditNotesAction,
  fetchOneOffChargeReasonFilters as fetchOneOffChargeReasonFiltersAction
} from './';

import {
  voidInvoices,
  fetchPayments,
  fetchScheduleTypesFilters,
  fetchXeroAccountsFilters,
  fetchCreditNotes,
  fetchOneOffChargeReasonFilters
} from 'sdk/payments';

function* paymentsSaga() {
  yield all([
    createFetchSagaLatest(fetchPaymentsAction, fetchPayments),
    createFetchSagaLatest(
      fetchScheduleTypesFiltersAction,
      fetchScheduleTypesFilters
    ),
    createFetchSagaLatest(
      fetchXeroAccountsFiltersAction,
      fetchXeroAccountsFilters
    ),
    createPostSagaLatest(voidInvoicesAction, voidInvoices),
    createFetchSagaLatest(fetchCreditNotesAction, fetchCreditNotes),
    createFetchSagaLatest(
      fetchOneOffChargeReasonFiltersAction,
      fetchOneOffChargeReasonFilters
    )
  ]);
}

export default paymentsSaga;
